import { formatTime, getFileCategory } from "../../utils/pip";

const MessageItem = ({ msg, isOwn }) => {
  return (
    <>
      {(msg.message_text || msg?.media_url?.length > 0) && (
        <li>
          <div className={`message ${isOwn ? "repaly" : "sender"}`}>
            {console.log({media_url : msg?.media_url})}
            {msg?.message_type?.trim() != "text" &&
              msg?.media_url?.length > 0 && (
                <div
                  className="d-flex align-items-center gap-2 flex-wrap ct_para_scroll ct_custom_scroll ct_sent_imges_56"
                  style={{ maxHeight: "150px" }}
                >
                  {msg.media_url?.map((file, i) => {
                    const fileCategory = getFileCategory(file.file_type);

                    return (
                      <a key={i} href={file.url} target="_blank">
                        {fileCategory === "video" && (
                          <video width="100" height="100" controls>
                            <source src={file.url} type={file.file_type} />
                          </video>
                        )}
                        {fileCategory === "image" && (
                          <img
                            src={file.url}
                            alt="preview"
                            className="ct_preview_img"
                          />
                        )}

                        {fileCategory === "file" && (
                          <div className="ct_pdf_uploaded_45">
                            <div className="text-center">
                              <i className="fa-regular fa-file-zipper text-center"></i>
                              <p
                                className="mb-0 ct_fs_12 ct_overlay_text text-center"
                                style={{ maxWidth: "63px" }}
                              >
                                {file.key || "File"}
                              </p>
                            </div>
                          </div>
                        )}
                      </a>
                    );
                  })}
                </div>
              )}

            {msg?.message_type != "media" && (
              <h5 class="ct_fs_16  mb-2 "> {msg.message_text}</h5>
            )}
            <small
              className={`ct_text_clr_9A96A4 text-${isOwn ? "end" : "start"} d-block`}
            >
              {formatTime(msg.created_at)}
            </small>
          </div>
        </li>
      )}
    </>
    // <div className={`message ${isOwn ? "own" : ""}`}>
    //   {msg.message && <p>{msg.message}</p>}

    //   {msg.attachments?.map((file, i) => (
    //     <a key={i} href={file.url} target="_blank">
    //       {file.type}
    //     </a>
    //   ))}
    // </div>
  );
};

export default MessageItem;
